"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var react_transition_group_1 = require("react-transition-group");
var config_1 = require("../config");
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { opened: false };
        _this.modal = null;
        _this.createElement = function () {
            if (!_this.modal) {
                _this.modal = document.createElement("div");
                document.getElementById(config_1.default.rootId).appendChild(_this.modal);
            }
        };
        _this.removeElement = function () {
            if (_this.modal) {
                _this.modal.remove();
                _this.modal = null;
            }
        };
        return _this;
    }
    default_1.prototype.render = function () {
        var _this = this;
        var _a = this.props, buttonComponent = _a.buttonComponent, buttonProps = _a.buttonProps, closed = _a.closed, contentComponent = _a.contentComponent, contentProps = _a.contentProps, onOpen = _a.onOpen, transitionClassNames = _a.transitionClassNames;
        var Button = buttonComponent;
        var Content = contentComponent;
        var opened = !closed && this.state.opened;
        return [
            (React.createElement(Button, __assign({ key: "button", opened: opened, openWindow: function () { return _this.setState({ opened: true }); } }, __assign({}, (buttonProps || {}))))),
            !!this.modal && ReactDOM.createPortal(React.createElement(react_transition_group_1.CSSTransition, { appear: true, classNames: transitionClassNames, in: opened, timeout: config_1.default.maxAnimationDelayMs, onEntered: onOpen, onExited: this.removeElement },
                React.createElement(Content, __assign({ closeWindow: function () { return _this.setState({ opened: false }); }, opened: opened }, __assign({}, (contentProps || {}))))), this.modal),
        ];
    };
    default_1.prototype.componentWillUpdate = function (_, _a) {
        var opened = _a.opened;
        if (!this.state.opened && opened) {
            this.createElement();
        }
    };
    default_1.prototype.componentDidUpdate = function (_a) {
        var closed = _a.closed;
        if (!closed && this.props.closed) {
            this.setState({ opened: false });
        }
    };
    default_1.prototype.componentWillUnmount = function () {
        this.removeElement();
    };
    return default_1;
}(React.Component));
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/component/ModalButton.tsx
// module id = 229
// module chunks = 0